<div class="dialog-content-wrapper">
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <h1 class="title">{{ "Booths" | translate }}</h1>
      <button
        mat-icon-button
        mat-dialog-close
        aria-label="Close dialog"
        (click)="matDialogRef.close()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div
    style="margin-left: 16px"
    class="filters"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayout.gt-xs="row"
    fxLayoutAlign.gt-xs="space-between center"
  >
    <mat-form-field floatLabel="always" class="course-search">
      <input matInput (input)="filterCardsByTerm($event.target.value)" />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
  </div>

  <div mat-dialog-content class="p-16 m-0 primary-50" fusePerfectScrollbar>
    <div
      fxFlex
      fxLayout="row"
      class="cardsize"
      fxLayoutAlign="space-between center"
    >
      <div fxLayout="column" class="primary-50 boothcards">
        <div fxFlex="1 0 100%" fxLayoutAlign="center center">
          <mat-spinner *ngIf="!dataLoaded"></mat-spinner>
        </div>
        <div class="p-12" *ngFor="let booth of filterBooths">
          <div fxFlex="1 1 100%">
            <mat-card class="example-card">
              <mat-card-header>
                <mat-card-title
                  >{{ "Booth No" | translate }} :
                  {{ booth.booth_number }}</mat-card-title
                >
              </mat-card-header>
              <mat-card-content>
                <p>{{ booth.area }}</p>
                <hr />
                <p>{{ booth.booth }}</p>
              </mat-card-content>
            </mat-card>
          </div>
          <div fxFlex="0 1 auto" fxLayoutAlign="space-between center">
            <div class="example-button-container ml-12">
              <section
                *ngIf="
                  config?.hide_have_branch == false || booth.have_branch == 0
                "
                class="example-section"
              >
                <button
                  (click)="boothSelected(true, booth)"
                  *ngIf="!booth.checked"
                  mat-mini-fab
                  style="background-color: green"
                  aria-label="Example icon button with a add list icon"
                >
                  <mat-icon>add</mat-icon>
                </button>

                <button
                  (click)="boothSelected(false, booth)"
                  *ngIf="booth.checked"
                  mat-mini-fab
                  color="warn"
                  aria-label="Example icon button with a remove list icon"
                >
                  <mat-icon>remove</mat-icon>
                </button>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <button mat-raised-button class="accent" (click)="onSave()">
      {{ "Save" | translate }}
    </button>
    <button mat-raised-button (click)="close()" class="red">
      {{ "Go Back" | translate }}
    </button>
  </div>
</div>
